<template>
  <div id="app">
    <keep-alive include="Home">
      <router-view v-if="state.loaded && (auth.loggedIn || state.anonymousRoute)"/>
      <Loading v-if="!state.loaded && !state.authenticated"/>
    </keep-alive>
  </div>
</template>
<script>
import update from "./mixins/update"
import {computed, defineComponent, reactive, watch} from "@vue/composition-api"
import {retrieveConfig} from "@/data/config"
import {auth, loadAuth, ssoRedirect} from "@/data/api/auth"
import router from "@/router"
import Loading from "@/components/Loading"

export default defineComponent({
  components: {Loading},
  mixins: [update],
  setup() {
    const state = reactive({
      loaded: false,
      anonymousRoute: computed(() => ["login", "auth"].includes(router.currentRoute.name)),
    })

    watch(() => auth.loggedIn, () => {
      // do not bother if authenticated or on noAuthRoute
      if (auth.loggedIn || state.anonymousRoute) return
      // Give loadAuth() some time to load user from browser session storage
      // and then redirect to login page if not logged in
      setTimeout(() => (!auth.loggedIn) && ssoRedirect(), 1500)
    }, {immediate: true})

    setTimeout(async() => {
      state.loaded = await retrieveConfig()
      console.log("Config OK/Status?:", state.loaded)
      if (!state.loaded) return
      if (!state.anonymousRoute) loadAuth()
    }, 0)
    return {state, auth}
  },
})
</script>
<style src="@/assets/styles/tailwind.min.css"></style>
